<div class="d-flex flex-column gap-3 px-5">
    <!-- Title -->
    <p class="text-center h8 lh-1">{{ "home.sponsorTitle" | transloco }}</p>
    <!-- Sponsors Flexbox -->
    <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
        <img class="img-fluid p-2 col-12 col-md-9 col-lg-6 col-xl-5" src="/assets/images/logos/sponsors/ASVZ-Sponsors.png"
            alt="Asvz Sponsoren">
    </div>
</div>